import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import ButtonLoader from "../../../components/ButtonLoader";

// Blur-backdrop confirmation for the "Cancel Request" option in the autorelease
// split button. Matches the AutoreleaseConfirmModal layout so the two read as a pair.
const CancelRequestConfirmModal = ({
  open,
  onClose,
  templateName,
  onConfirm,
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 backdrop-blur-sm bg-transparent transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl ring-1 ring-gray-200 transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
              <XCircleIcon className="size-6 text-red-600" aria-hidden="true" />
            </div>

            <div className="mt-3 text-center sm:mt-5">
              <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                Cancel Request
              </DialogTitle>
              <div className="mt-3">
                <p className="text-sm text-gray-700 leading-relaxed">
                  Are you sure you want to cancel the{" "}
                  <span className="font-semibold">
                    {templateName || "Diligent"}
                  </span>{" "}
                  VQQ request? This action cannot be undone — the sponsor will be
                  notified that you declined to respond.
                </p>
              </div>
            </div>

            <div className="mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                onClick={onConfirm}
                disabled={loading}
                className={`inline-flex w-full justify-center items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:col-start-2 transition ${
                  loading
                    ? "bg-red-400 cursor-not-allowed"
                    : "bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                }`}
              >
                {loading ? (
                  <>
                    <ButtonLoader />
                    <span>Cancelling…</span>
                  </>
                ) : (
                  "Confirm"
                )}
              </button>
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                data-autofocus
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
              >
                Keep Request
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default CancelRequestConfirmModal;
